import { call, put, all, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";
import { handleError } from "./ApiError";
import {
    GET_REPORTS,
    SG_GET_REPORTS,
    FETCH_REPORT,
    SG_FETCH_REPORT,
    UPDATE_REPORT,
    SG_UPDATE_REPORT,
    DELETE_REPORT,
    SG_DELETE_REPORT,
    GET_REPORTS_GENERATION_QUEUE,
    SG_GET_REPORTS_GENERATION_QUEUE,
    REGENERATE_REPORT_DIMENSION,
    SG_REGENERATE_REPORT_DIMENSION,
} from "constants/actions";

/* Reports */

function* loadReports(action) {
      console.log("Reports fetched:");
    try {
    const json = yield call(api.GET_APV2_REPORTS, action.payload);
    console.log("Reports fetched:", json);
        yield put({ type: GET_REPORTS, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* reportsLoad() {
    yield takeLatest(SG_GET_REPORTS, loadReports);
}

function* fetchReport(action) {
    try {
    const json = yield call(api.FETCH_APV2_REPORT, action.payload);
        yield put({ type: FETCH_REPORT, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* reportFetch() {
    yield takeLatest(SG_FETCH_REPORT, fetchReport);
}

function* updateReport(action) {
    try {
    const json = yield call(api.EDIT_APV2_REPORT, action.payload);
        yield put({ type: UPDATE_REPORT, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* reportUpdate() {
    yield takeLatest(SG_UPDATE_REPORT, updateReport);
}


function* regenerateReport(action) {
    try {
    const json = yield call(api.REGENERATE_APV2_REPORT, action.payload);
        yield put({ type: REGENERATE_REPORT_DIMENSION, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* reportRegenerate() {
    yield takeLatest(SG_REGENERATE_REPORT_DIMENSION, regenerateReport);
}

function* deleteReport(action) {
    try {
    const json = yield call(api.DELETE_APV2_REPORT, action.payload);
        yield put({ type: DELETE_REPORT, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* reportDelete() {
    yield takeLatest(SG_DELETE_REPORT, deleteReport);
}

function* loadReportsGenerationQueue() {
    try {
    const json = yield call(api.REPORT_GENERATION_QUEUE);
    yield put({ type: GET_REPORTS_GENERATION_QUEUE, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* reportsGenerationQueueLoad() {
    yield takeLatest(SG_GET_REPORTS_GENERATION_QUEUE, loadReportsGenerationQueue);
}

export default function* index() {
    yield all([
    reportsLoad(),
    reportFetch(),
    reportUpdate(),
    reportRegenerate(),
    reportDelete(),
    reportsGenerationQueueLoad(),
    ]);
}
